import { Card } from '@cocoonspace/ui/components/card'
import { useLingui } from '@lingui/react/macro'
import Image from 'next/image'
import { SectionTitle } from '~/domains/home/components/section-title'
import { SectionWrapper } from '~/domains/home/components/section-wrapper'

export const TeamSection = () => {
	const { t } = useLingui()

	return (
		<div className='bg-white'>
			<SectionWrapper>
				<SectionTitle>{t`Une équipe à votre service`}</SectionTitle>

				<div className='flex flex-col gap-6 md:flex-row'>
					<div className='order-2 flex flex-1 flex-col justify-center gap-4 md:order-1'>
						<div className='font-bold text-lg'>
							{t`Depuis 9 ans, nos équipes sont à vos côté :`}
						</div>

						<ul className='prose ml-4 list-disc'>
							<li>{t`L'équipe support client répond 7j7 de 8h à 23h.`}</li>
							<li>{t`L'équipe opérationnelle assure le bon fonctionnement de vos équipements.`}</li>
							<li>{t`L'équipe vente vous accompagne dans l'organisation de votre évènement pour 1h ou plusieurs jours.`}</li>
						</ul>
					</div>

					<Card className='relative order-1 aspect-video overflow-hidden rounded bg-cover md:order-2 md:w-[550px]'>
						<Image
							alt='Equipe Cocoon Space'
							className='z-0 object-cover object-left'
							fill
							src='/images/team.jpg'
						/>
					</Card>
				</div>
			</SectionWrapper>
		</div>
	)
}
